// The art reference capture omits only the environment plate; board geometry stays live.
export const isArtLayoutCapture = typeof window !== "undefined" && new URLSearchParams(window.location.search).has("art-layout");
const requestedLevel = typeof window !== "undefined" ? Number(new URLSearchParams(window.location.search).get("level")) : 1;
export const artLayoutLevel = Number.isSafeInteger(requestedLevel) && requestedLevel > 0 ? requestedLevel : 1;
